export const getValidityText = (validityMonths: number, expiryDate: string): string | undefined => {
  const expiDate = new Date(expiryDate);
  const isSingle = validityMonths < 2;

  const options: any = { year: 'numeric', month: 'long', day: 'numeric' };

  if (!validityMonths && !expiryDate) {
    return null;
  }
  if (!expiryDate) {
    return `${validityMonths.toString()} ${isSingle ? 'Month' : 'Months'}`;
  }
  return `Valid on or before ${expiDate.toLocaleDateString('en-GB', options)}`;
};
